import React from 'react';
import { useGlobal } from '../../contexts/Global/context';

import Icon from '../Icons';

import * as S from './styles';

function Modal({ children, subtitle, modalSize = 'sm', ...rest }) {
    const { contrastTheme } = useGlobal();
    const defaultProps = {
        closeIcon: <Icon name="close" type="round" size={20} color={contrastTheme ? '#FFF333' : '#5B5B5F'} />,
        maskClosable: false,
        keyboard: true,
    };

    return (
        <S.StyledModal centered className={`modal-${modalSize}`} {...defaultProps} {...rest}>
            {subtitle} <S.ContainerButtonModal>{children}</S.ContainerButtonModal>
        </S.StyledModal>
    );
}

export default Modal;
